export default __webpack_public_path__ + "static/media/internet.5d65f8e7.svg";